// extracted by mini-css-extract-plugin
module.exports = {"prefixWrapper":"antd-pro-ui-input-number-index-prefixWrapper","prefix":"antd-pro-ui-input-number-index-prefix"};